module.exports = __webpack_public_path__ + "static/media/DSC_0451.088f83b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/scenery/DSC_0451.jpg
// module id = 698
// module chunks = 0